import { useState } from 'react';

const useTotalCostInfo = () => {
  const [totalCostInfo, setTotalCostInfo] = useState({
    order_total: '',
    shipping_price: '',
    sub_total: '',
    tax: '',
    discount: '',
  });

  return { totalCostInfo, setTotalCostInfo };
};

export default useTotalCostInfo;
